<nav class="navbar navbar-expand-xl navbar-dark bg-primary">
  <div class="container-fluid px-3">
    <!-- Brand/Logo -->
    <a class="navbar-brand d-flex align-items-center" routerLink="/">
      <img
        src="/assets/img/OrderUp.png"
        alt="OrderUp Logo"
        class="me-2"
        width="40"
        height="40">
      <strong>OrderUp</strong>
    </a>

    <!-- Mobile menu button -->
    <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav">
      <span class="navbar-toggler-icon"></span>
    </button>

    <!-- Desktop Navigation -->
    <div class="collapse navbar-collapse" id="navbarNav">
      <ul class="navbar-nav me-auto">
        <li class="nav-item">
          <a class="nav-link" routerLink="/customer" routerLinkActive="active">
            <i class="fas fa-user"></i> Customer
          </a>
        </li>
        <li class="nav-item">
          <a class="nav-link" routerLink="/restaurants" routerLinkActive="active">
            <i class="fas fa-store"></i> Restaurants
          </a>
        </li>
        <li class="nav-item">
          <a class="nav-link" routerLink="/orders" routerLinkActive="active">
            <i class="fas fa-receipt"></i> My Orders
          </a>
        </li>
        <li class="nav-item">
          <a class="nav-link" routerLink="/missions" routerLinkActive="active">
            <i class="fas fa-route"></i> Missions
          </a>
        </li>
        <li class="nav-item">
          <a class="nav-link" routerLink="/investigations" routerLinkActive="active">
            <i class="fas fa-magnifying-glass"></i> Investigations
          </a>
        </li>
      </ul>

      <ul class="navbar-nav">
        <!-- The visitor's demoCode, shown with the callouts (spec section 1) -->
        @if (nrConfig.showCallouts()) {
          <li class="nav-item">
            <span class="nav-link disabled" title="Your code - your data in New Relic carries this as demoCode">
              <span class="demo-code">{{ demoIdentity.code() }}</span>
            </span>
          </li>
        }

        <!-- Show or hide the New Relic "Behind the scenes" callouts -->
        <li class="nav-item">
          <a class="nav-link nr-toggle" [class.nr-toggle-on]="nrConfig.showCallouts()" href="#" role="button"
            [attr.aria-pressed]="nrConfig.showCallouts()"
            (click)="$event.preventDefault(); nrConfig.toggleCallouts()">
            <i class="fas" [class.fa-eye]="nrConfig.showCallouts()" [class.fa-eye-slash]="!nrConfig.showCallouts()"></i>
            Behind the scenes
          </a>
        </li>

        <!-- Cart -->
        @if (cartItemCount > 0) {
          <li class="nav-item dropdown">
            <a class="nav-link dropdown-toggle position-relative" href="#" role="button" data-bs-toggle="dropdown">
              <i class="fas fa-shopping-cart"></i>
              <span class="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger">
                {{ cartItemCount }}
              </span>
            </a>
            <div class="dropdown-menu dropdown-menu-end">
              <h6 class="dropdown-header">
                <i class="fas fa-shopping-cart"></i> Cart Summary
              </h6>
              <div class="dropdown-item-text">
                <div class="d-flex justify-content-between">
                  <span>{{ cartItemCount }} item(s)</span>
                  <strong>${{ (cartTotal || 0).toFixed(2) }}</strong>
                </div>
              </div>
              <div class="dropdown-divider"></div>
              <a class="dropdown-item text-center" routerLink="/checkout">
                <i class="fas fa-credit-card"></i> Proceed to Checkout
              </a>
            </div>
          </li>
        }

        <!-- Cart button when no items -->
        @if (cartItemCount === 0) {
          <li class="nav-item">
            <a class="nav-link" routerLink="/checkout">
              <i class="fas fa-shopping-cart"></i> Cart
            </a>
          </li>
        }

        <!-- Help -->
        <li class="nav-item dropdown">
          <a class="nav-link dropdown-toggle" href="#" role="button" data-bs-toggle="dropdown">
            <i class="fas fa-question-circle"></i>
          </a>
          <ul class="dropdown-menu dropdown-menu-end">
            <li><a class="dropdown-item" routerLink="/how-it-works">
              <i class="fas fa-cogs"></i> How it Works
            </a></li>
            <li><a class="dropdown-item" routerLink="/who-we-are">
              <i class="fas fa-users"></i> About Us
            </a></li>
          </ul>
        </li>
      </ul>
    </div>
  </div>
</nav>

<!-- Which investigation is live (spec section 11); always shown -->
@if (nrConfig.armedInvestigation(); as inv) {
  <div class="scenario-banner">
    <i class="fas fa-magnifying-glass me-2"></i>
    <span>
      <strong>Investigation live:</strong> {{ NrConfigService.describeInvestigation(inv) }}
      <a routerLink="/investigations">Open the investigation</a>
      @switch (inv.source) {
        @case ('manual') { <span class="scenario-source">(set by the instructor)</span> }
        @case ('env') { <span class="scenario-source">(set in the server environment)</span> }
      }
    </span>
  </div>
}

<!-- Which demo failure is armed, so nobody has to guess; always shown -->
@if (nrConfig.armedScenario(); as scenario) {
  <div class="scenario-banner">
    <i class="fas fa-clapperboard me-2"></i>
    <span>
      <strong>Behind the scenes:</strong> {{ NrConfigService.describeScenario(scenario) }}
      @switch (scenario.source) {
        @case ('rotation') { <span class="scenario-source">(this week's rotation — it changes weekly)</span> }
        @case ('manual') { <span class="scenario-source">(set by the instructor)</span> }
        @case ('env') { <span class="scenario-source">(set in the server environment)</span> }
      }
    </span>
  </div>
}

<!-- Live order pill: follows the tracked order until it lands -->
@if (orderStatus.pillVisible()) {
  <div
    class="order-pill"
    [class.delivered]="orderStatus.status() === 'delivered'"
    [class.cancelled]="orderStatus.status() === 'cancelled'"
  >
    <a class="order-pill-link" routerLink="/orders">
      <i class="fas fa-pizza-slice me-2"></i>
      <span class="order-pill-text">
        @if (orderStatus.restaurantName(); as name) {
          <strong>{{ name }}</strong> ·
        }
        {{ orderStatus.statusLabel() }}
      </span>
      <span class="order-pill-progress" aria-hidden="true">
        @for (stage of ORDER_STAGES; track stage.key; let i = $index) {
          <span
            class="order-pill-segment"
            [class.done]="orderStatus.stageIndex() > i"
            [class.current]="orderStatus.stageIndex() === i"
          ></span>
        }
      </span>
    </a>
    <button
      type="button"
      class="order-pill-close"
      aria-label="Dismiss order tracker"
      (click)="orderStatus.dismiss()"
    >
      <i class="fas fa-times"></i>
    </button>
  </div>
}
